export default __webpack_public_path__ + "static/media/video.9b60ca53.mp4";